import React, { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaWhatsapp, FaFacebookF, FaPhoneAlt } from 'react-icons/fa';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    mailid: '',
    number: '',
    question: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/contact`, formData);
      alert('Message sent successfully!');
      setFormData({ name: '', mailid: '', number: '', question: '' });
    } catch (error) {
      console.error('Contact form submission error:', error);
      alert('Error sending message. Please try again.');
    }
  };

  return (
    <div className="bg-white text-black pb-[80px] sm:pb-[100px] md:pb-[120px] lg:pb-[160px]">
      {/* Hero Section */}
      <section className="relative w-full h-[500px] sm:h-[600px] md:h-[700px]">
        <img
          src="/images/askulama.jpg"
          alt="Mosque"
          className="w-full h-full object-cover brightness-75"
        />
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-8">
          <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black mb-4 sm:mb-6 drop-shadow-lg uppercase leading-tight">
            Get in Touch<br className="sm:hidden"/> with Ulama
          </h1>
          <p className="text-white max-w-2xl text-sm sm:text-base md:text-lg lg:text-xl drop-shadow-md font-light leading-relaxed px-4">
            Reach out for support, queries, or collaboration. We're here to help you.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <div className="max-w-7xl mx-auto py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12">
        
        {/* Image Section */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="flex items-center justify-center"
        >
          <img
            src="/images/mosque4.jpg"
            alt="Contact"
            className="w-full h-[350px] sm:h-[400px] md:h-[500px] lg:h-[550px] object-cover rounded-2xl shadow-2xl"
          />
        </motion.div>

        {/* Contact Form */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-2xl p-6 sm:p-8 md:p-10"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-center mb-6 sm:mb-8 uppercase">
            Send Us a Message
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-5 md:space-y-6">
            <div>
              <label className="block font-black mb-2 text-sm sm:text-base uppercase">Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full p-3 sm:p-4 rounded-xl border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-black font-light text-sm sm:text-base"
                placeholder="Your Name"
                required
              />
            </div>
            <div>
              <label className="block font-black mb-2 text-sm sm:text-base uppercase">Email</label>
              <input
                type="email"
                name="mailid"
                value={formData.mailid}
                onChange={handleChange}
                className="w-full p-3 sm:p-4 rounded-xl border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-black font-light text-sm sm:text-base"
                placeholder="Your Email"
                required
              />
            </div>
            <div>
              <label className="block font-black mb-2 text-sm sm:text-base uppercase">Phone</label>
              <input
                type="text"
                name="number"
                value={formData.number}
                onChange={handleChange}
                className="w-full p-3 sm:p-4 rounded-xl border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-black font-light text-sm sm:text-base"
                placeholder="Your Phone Number"
                required
              />
            </div>
            <div>
              <label className="block font-black mb-2 text-sm sm:text-base uppercase">Your Question</label>
              <textarea
                name="question"
                rows="4"
                value={formData.question}
                onChange={handleChange}
                className="w-full p-3 sm:p-4 rounded-xl border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-black font-light text-sm sm:text-base resize-none"
                placeholder="Write your message..."
                required
              ></textarea>
            </div>
            <div className="text-center pt-2">
              <button
                type="submit"
                className="bg-black text-white px-6 sm:px-8 md:px-10 py-3 sm:py-3.5 rounded-xl hover:bg-gray-800 transition-all duration-300 font-black text-sm sm:text-base md:text-lg hover:scale-105 shadow-md hover:shadow-xl uppercase"
              >
                Send Message
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default ContactUs;




// import React, { useState } from 'react';
// import axios from 'axios';
// import { motion } from 'framer-motion';
// import { FaMapMarkerAlt, FaWhatsapp, FaFacebookF, FaPhoneAlt } from 'react-icons/fa';

// const ContactUs = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     mailid: '',
//     number: '',
//     question: '',
//   });

//   const handleChange = (e) => {
//     setFormData(prev => ({
//       ...prev,
//       [e.target.name]: e.target.value,
//     }));
//   };

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/contact`, formData);
//     alert('Message sent successfully!');
//     setFormData({ name: '', mailid: '', number: '', question: '' });
//   } catch (error) {
//     console.error('Contact form submission error:', error);
//     alert('Error sending message. Please try again.');
//   }
// };


//   return (
//     <div className="bg-white text-black pb-[100px] md:pb-[160px] lg:pb-[160px]">
//       {/* Hero Section */}
//       <section className="relative w-full h-[700px]">
//         <img
//           src="/images/askulama.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover brightness-75"
//         />
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
//           <h1 className="text-white text-4xl md:text-6xl font-bold mb-6 drop-shadow-lg">
//             Get in Touch with Ulama
//           </h1>
//           <p className="text-white max-w-2xl text-lg md:text-xl drop-shadow-md">
//             Reach out for support, queries, or collaboration. We're here to help you.
//           </p>
//         </div>
//       </section>

//       {/* Contact Section */}
//       <div className="max-w-8xl  mx-auto py-20 px-6 grid grid-cols-1 lg:grid-cols-2 gap-12">
//       {/* Contact Info with Image and Address */}
// {/* Image Section ONLY */}
// <motion.div
//   initial={{ opacity: 0, x: -50 }}
//   animate={{ opacity: 1, x: 0 }}
//   transition={{ duration: 0.8 }}
//   className="flex items-center justify-center"
// >
//   <img
//     src="/images/mosque4.jpg"
//     alt="Contact"
//     className="w-full h-[550px] object-cover rounded-2xl shadow-lg"
//   />
// </motion.div>



//         {/* Contact Form */}
//         <motion.div
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8 }}
//           className="bg-white rounded-2xl md:p-10  "
//         >
//           <h2 className=" text-2xl md:text-4xl font-bold text-center mb-8">Send Us a Message</h2>
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div>
//               <label className="block font-medium mb-2">Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Your Name"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-2">Email</label>
//               <input
//                 type="email"
//                 name="mailid"
//                 value={formData.mailid}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Your Email"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-2">Phone</label>
//               <input
//                 type="text"
//                 name="number"
//                 value={formData.number}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Your Phone Number"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-2">Your Question</label>
//               <textarea
//                 name="question"
//                 rows="4"
//                 value={formData.question}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Write your message..."
//                 required
//               ></textarea>
//             </div>
//             <div className="text-center">
//               <button
//                 type="submit"
//                 className="bg-black text-white px-6 py-3 rounded-xl hover:bg-gray-800 transition-all"
//               >
//                 Send Message
//               </button>
//             </div>
//           </form>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;










// import React, { useState } from 'react';
// import axios from 'axios';
// import { motion } from 'framer-motion';
// import { FaMapMarkerAlt, FaWhatsapp, FaFacebookF, FaPhoneAlt } from 'react-icons/fa';

// const ContactUs = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     mailid: '',
//     number: '',
//     question: '',
//   });

//   const handleChange = (e) => {
//     setFormData(prev => ({
//       ...prev,
//       [e.target.name]: e.target.value,
//     }));
//   };

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/contact`, formData);
//     alert('Message sent successfully!');
//     setFormData({ name: '', mailid: '', number: '', question: '' });
//   } catch (error) {
//     console.error('Contact form submission error:', error);
//     alert('Error sending message. Please try again.');
//   }
// };


//   return (
//     <div className="bg-white text-black pb-[100px] md:pb-[160px] lg:pb-[160px]">
//       {/* Hero Section */}
//       <section className="relative w-full h-[700px]">
//         <img
//           src="/images/askulama.jpg"
//           alt="Mosque"
//           className="w-full h-full object-cover brightness-75"
//         />
//         <div className="absolute inset-0 bg-black opacity-50"></div>
//         <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
//           <h1 className="text-white text-4xl md:text-6xl font-bold mb-6 drop-shadow-lg">
//             Get in Touch with Ulama
//           </h1>
//           <p className="text-white max-w-2xl text-lg md:text-xl drop-shadow-md">
//             Reach out for support, queries, or collaboration. We're here to help you.
//           </p>
//         </div>
//       </section>

//       {/* Contact Section */}
//       <div className="max-w-8xl  mx-auto py-20 px-6 grid grid-cols-1 lg:grid-cols-2 gap-12">
//       {/* Contact Info with Image and Address */}
// <motion.div
//   initial={{ opacity: 0, x: -50 }}
//   animate={{ opacity: 1, x: 0 }}
//   transition={{ duration: 0.8 }}
//   className=" rounded-2xl md:p-8  flex flex-col items-center text-center"
// >
//   {/* Image */}
//   <img
//     src="/images/mosque4.jpg" // Replace with your image path
//     alt="Our Location"
//     className="w-full h-96 object-cover rounded-xl mb-6"
//   />

//   {/* Address Section */}
//   <div className="w-full pt-16">
//     <h3 className="text-2xl md:text-4xl font-bold text-black mb-3">Our Address</h3>
//     <div className='flex justify-center'>
//     <p className="text-gray-700 md:text-lg max-w-sm">
//     1st Floor, 9-63-63, Markazi Masjid AhleHadees, Hameed Street, Syed Gulab St, Kothapet, Islampet, Vijayawada, Andhra Pradesh 520001
//     </p>
//     </div>
   
//   </div>

//   {/* Icons Section */}
//   <div className="mt-8 space-y-5 w-full">
//     <div className="flex justify-center items-center gap-3">
//       <FaPhoneAlt className="text-black text-2xl" />
//       <span className="md:text-lg">+91 99633 72233</span>
//     </div>
//     <div className="flex justify-center items-center gap-3">
//       <FaWhatsapp className="text-black text-2xl" />
//       <span className="md:text-lg">+91 99633 72233</span>
//     </div>
//     <div className="flex justify-center items-center gap-3">
//       <FaFacebookF className="text-black text-2xl" />
//       <a
//         href="https://facebook.com/subaijamiatahlehadeesandhrapradesh"
//         target="_blank"
//         rel="noopener noreferrer"
//         className="md:text-lg hover:underline "
//       >
//         Subai Jamiat Ahle Hadees Andhrapradesh
//       </a>
//     </div>
//   </div>
// </motion.div>


//         {/* Contact Form */}
//         <motion.div
//           initial={{ opacity: 0, x: 50 }}
//           animate={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.8 }}
//           className="bg-white rounded-2xl md:p-10  "
//         >
//           <h2 className=" text-2xl md:text-4xl font-bold text-center mb-8">Send Us a Message</h2>
//           <form onSubmit={handleSubmit} className="space-y-6">
//             <div>
//               <label className="block font-medium mb-2">Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Your Name"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-2">Email</label>
//               <input
//                 type="email"
//                 name="mailid"
//                 value={formData.mailid}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Your Email"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-2">Phone</label>
//               <input
//                 type="text"
//                 name="number"
//                 value={formData.number}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Your Phone Number"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block font-medium mb-2">Your Question</label>
//               <textarea
//                 name="question"
//                 rows="4"
//                 value={formData.question}
//                 onChange={handleChange}
//                 className="w-full p-4 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black"
//                 placeholder="Write your message..."
//                 required
//               ></textarea>
//             </div>
//             <div className="text-center">
//               <button
//                 type="submit"
//                 className="bg-black text-white px-6 py-3 rounded-xl hover:bg-gray-800 transition-all"
//               >
//                 Send Message
//               </button>
//             </div>
//           </form>
//         </motion.div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;

